<template>
  <div class="product-page">
    <div class="left-text">
      <div
        class="left-text__back"
        :style="{
          height: textHeight + 'px',
        }"
      >
        <div
          class="left-text__parallax"
          :style="{
            height: 100 * offsets.length + 'vh',
            transform: parallaxTransform2,
          }"
        ></div>
      </div>
      <div class="left-text__text"></div>
    </div>
    <div
      class="parallax-bg"
      :style="{
        height: 100 * offsets.length + '%',
        transform: parallaxTransform,
      }"
    ></div>
    <div class="sections-next" @click="scrollToSection(activeSection + 1)" v-if="activeSection != offsets.length - 1" :style="{
        marginBottom: textHeight + 'px',
      }">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
        <path d="M0.788574 0.884466L5.50011 5.86523L10.2117 0.884466" stroke="#20438C" stroke-width="2"/>
      </svg>
    </div>
    <div class="sections-prev" @click="scrollToSection(activeSection - 1)" v-if="activeSection != 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
        <path d="M10.2114 6.78839L5.49989 1.80762L0.788349 6.78839" stroke="#20438C" stroke-width="2"/>
      </svg>
    </div>
    <div
      class="sections-menu"
      :style="{
        marginTop: -(textHeight - headerHeight) / 2 + 'px',
      }"
    >
      <span
        class="menu-point"
        v-bind:class="{ active: activeSection == index }"
        v-on:click="scrollToSection(index)"
        v-for="(offset, index) in offsets"
        v-bind:key="index"
      >
      </span>
    </div>
    <div ref="packOverlay" class="cigarettes-pack-page cigarettes-pack-page-2">
      <!--
      <iframe id="cigarettes-pack-page__model"
              src="https://www.vectary.com/viewer/v1/?model=ef987679-4930-4a29-93cf-8995717166c9&&arAllowScaling=0&lang=ru&showPreloader=1&showPlaceholder=0&showInteractionPrompt=0&zoom=0&pan=0&rotateY=0&doubleClickToFocus=0&env=snowyforest&exposure=10&gamma=1.5&noAr=1"
              allowtransparency="false"
              frameborder="0"
              width="100%"
              height="100%">
      </iframe>
      -->
      <transition name="fade">
        <div class="cigarettes-pack-page__360" v-if="show360"></div>
      </transition>
      <div id="cigarettes-pack-page-2__handle">
        <svg width="64" height="121" viewBox="0 0 64 121" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M48.2829 59.1517C47.8754 61.4609 48.4187 70.2899 50.592 70.6974L53.4444 51.5452C53.5803 50.866 54.1236 47.8778 52.9011 46.3836C52.0861 45.297 50.3203 43.9387 47.1962 44.7536L46.6529 48.2853C48.0112 47.6061 48.8262 48.2853 49.2337 48.6927C49.6412 49.2361 49.6412 50.1869 49.5053 50.5944L48.2829 59.1517ZM34.5639 38.2338C37.4164 37.5546 39.318 38.2338 40.133 39.3204C41.763 41.3579 41.0838 44.7536 40.948 45.4328L38.3672 63.9058C36.1939 63.4983 35.3789 56.0276 35.6506 53.8543L36.8731 44.6178C37.0089 44.2103 37.0089 43.1237 36.6014 42.5803C36.1939 42.037 35.3789 41.4937 34.0206 42.1729L34.5639 38.2338ZM24.1049 60.2384C21.9316 59.8309 21.1167 55.0768 22.3391 49.6436C24.9199 37.6904 27.5007 17.4516 28.3157 13.5125C29.674 6.17763 28.859 4.54765 24.5124 3.59684C21.5242 2.91768 18.5359 5.22681 17.7209 7.53594V6.72095C18.6717 1.15188 22.0675 0.608554 25.1916 0.744385C28.7232 0.880216 32.934 3.59684 32.5265 8.07926C31.8473 12.8333 27.3649 42.852 24.1049 60.2384ZM26.6857 120.547C26.6857 120.547 13.5101 120.412 5.08859 110.088C-2.38212 100.988 1.42115 82.1072 1.42115 82.1072L3.86612 69.0674C5.90359 69.4749 6.58274 74.229 5.90358 77.3531L5.08859 82.9222C5.08859 83.058 0.877826 100.173 8.48436 108.323C13.1026 113.348 19.3509 116.608 27.9082 117.016C36.4656 117.423 42.3063 115.522 47.0604 110.224C55.2103 101.259 56.9761 86.7254 57.6552 83.058L59.6927 67.8449C59.6927 67.1658 59.9643 66.215 59.5568 65.8075C59.1494 65.4 58.3344 64.7208 56.976 65.2641L57.3835 61.7325C59.8285 60.7817 61.4585 62.14 62.2735 63.0908C64.0393 65.1283 63.4959 67.8449 63.3601 68.5241L61.5943 82.1072C61.5943 82.1072 59.5568 102.482 50.592 112.398C50.7278 112.398 43.5288 121.906 26.6857 120.547Z" fill="white"/>
        </svg>
      </div>
    </div>
    <div
      id="fp"
      :style="{
        height: containerHeight + 'px',
      }"
    >
      <section
        class="fullpage"
        :class="{active: animateIndex == index}"
        v-for="(item, key, index) in $slots"
        :key="index"
      >
        <div>
          <transition name="slide-left">
            <div
              v-show="animateIndex == index"
              class="animate-block"
              ref="anim"
            >
              <slot :name="key"></slot>
            </div>
          </transition>
          <div v-if="nextButton.url && offsets.length == index + 1" class="_g-hidden-tablet">
            <div class="root-more _product">
              <div class="container">
                <transition name="slide-right">
                  <div v-show="animateIndex == index">
                    <router-link :to="{ path: nextButton.url }" class="button button__lg button__blue button__arrow" v-html="nextButton.text"></router-link>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

import productMixin from "../mixins/productMixin";

export default {
  name: 'ProductPage',
  mixins: [productMixin],
  methods: {
    async animatePack() {
    },
    async moveCigarette() {
    },
    async switchPack() {
    },
  },
};
</script>

